import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      style={{
        // Sonner reads these CSS vars on the wrapper to color the toast.
        // Defaults are too low-contrast in both modes, so we set explicit
        // high-contrast values that work for success/info/error variants.
        "--normal-bg":          theme === "dark" ? "#1e293b" : "#ffffff",  // slate-800 / white
        "--normal-text":        theme === "dark" ? "#f1f5f9" : "#0f172a",  // slate-100 / slate-900
        "--normal-border":      theme === "dark" ? "#334155" : "#e2e8f0",  // slate-700 / slate-200
        "--success-bg":         theme === "dark" ? "#1e293b" : "#ffffff",
        "--success-text":       theme === "dark" ? "#f1f5f9" : "#0f172a",
        "--success-border":     theme === "dark" ? "#059669" : "#10b981",  // emerald-600/500
        "--error-bg":           theme === "dark" ? "#1e293b" : "#ffffff",
        "--error-text":         theme === "dark" ? "#f1f5f9" : "#0f172a",
        "--error-border":       theme === "dark" ? "#dc2626" : "#ef4444",  // red-600/500
      }}
      toastOptions={{
        // High-contrast description that wins over Sonner's defaults — both modes.
        // We use inline style on the description via a className trick + a CSS
        // rule in index.css that targets [data-description] with high specificity.
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[var(--normal-bg)] group-[.toaster]:text-[var(--normal-text)] group-[.toaster]:border-[var(--normal-border)] group-[.toaster]:shadow-lg",
          title:       "group-[.toast]:text-slate-900 dark:group-[.toast]:text-slate-100 group-[.toast]:font-semibold",
          description: "group-[.toast]:!text-slate-700 dark:group-[.toast]:!text-slate-200 group-[.toast]:!opacity-100",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
